import { useState, createContext, useContext, useEffect } from 'react'
import { Modal } from 'antd'
import { useLocation, useNavigationType } from 'react-router-dom'
import WizrText from '../../components/WizrText'
import CreateUpdateFolderForm from '../../components/forms/CreateUpdateFolder'
import DeleteFileForm from '../../components/forms/DeleteFile'
import MultiUploadList from '../../components/forms/MultiUploadList'
import DeleteFolderForm from '../../components/forms/DeleteFolder'
import { styled } from 'styled-components'
import WizrFlexLayout from '../../components/WizrFlexLayout'
import AddTagsForm from '../../components/forms/AddTags'
import AddExamplesForm from '../../components/forms/AddExamples'
import AddCommentsForm from '../../components/forms/AddComments'
import AddParameterForm from '../../components/forms/AddParameter'
import LogoutConfirm from '../../components/forms/Logout'
import ConfirmationForm from '../../components/forms/Confirmation'
import UploadUrlForm from '../../components/forms/UploadUrl'
import CreateAppForm from '../../components/forms/CreateAppForm'
import FilePreviewer from '../../components/forms/FilePreviewer'
import selectTenant from '../../components/forms/SelectTenant'
import EditUserDetails from '../../components/popovers/EditUserDetails'
import ProductUpdate from '../../components/forms/ProductUpdate'
import AddRoles from '../../components/forms/AddRoles'
import AddPackages from '../../components/forms/AddPackages'
import AddIntegrations from '../../components/forms/AddIntegrations'
import CreateGroup from '../../components/forms/CreateGroup'
import CreateUpdatePastTicketsForm from '../../components/forms/CreatePastTickets'
import TicketSettings from '../../components/forms/TicketSettings'
import Persona from '../../components/forms/Persona'
import AddName from '../../components/forms/AddName'
import CreateTeam from '../../components/forms/CreateTeam'
import CreateDataset from '../../components/forms/CreateDataset'
import ImportPastTickets from '../../components/forms/ImportPastTickets'
import ControlroomFilter from '../../components/forms/ControlroomFilter'
import AddSchedule from '../../components/forms/AddSchedule'
import AgentTypeSelection from '../../components/forms/AgentTypeSelection'
import UploadConfluenceForm from '../../components/forms/UploadConfluenceForm'
import AddSourceModal from '../../components/modals/AddSourceModal'
import UploadSlackForm from '../../components/forms/UploadSlackForm'
import EditCustomField from '../../components/modals/EditCustomField'
import UploadSharePointForm from '../../components/forms/UploadSharePointForm'
import NewAlertForm from '../../components/forms/NewAlert'
import NewReportForm from '../../components/forms/NewReport'
import TicketDetailsModal from '../../components/forms/TicketDetailsModal'
import ImportAutosolveProgress from '../../components/modals/ImportAutosolveProgress'
import ImportWorkflowProgress from '../../components/modals/ImportWorkflowProgress'
import ImportWorkflowNameConflict from '../../components/modals/ImportWorkflowNameConflict'
import ExportWorkflowWarning from '../../components/modals/ExportWorkflowWarning'
import ImportWorkflowWarning from '../../components/modals/ImportWorkflowWarning'
import CreateLlmDbForm from '../../components/forms/CreateLlmDbForm'
import InsightsCustomApiModal from '../../components/modals/InsightsCustomApiModal'


const StyledLayout = styled(WizrFlexLayout)`
`

const MODAL_TYPES = {
  CREATE_UPDATE_FOLDER: 'CREATE_UPDATE_FOLDER',
  UPDATE_FILE: 'UPDATE_FILE',
  DELETE_FILE: 'DELETE_FILE',
  MULTI_FILE_UPLOAD: 'MULTI_FILE_UPLOAD',
  DELETE_FOLDER: 'DELETE_FOLDER',
  ADD_TAGS: 'ADD_TAGS',
  ADD_EXAMPLES: 'ADD_EXAMPLES',
  ADD_COMMENTS: 'ADD_COMMENTS',
  ADD_PARAMETER: 'ADD_PARAMETER',
  EDIT_PARAMETER: 'EDIT_PARAMETER',
  LOGOUT: 'LOGOUT',
  CONFIRMATION: 'CONFIRMATION',
  UPLOAD_URL: 'UPLOAD_URL',
  CONFLUENCE_UPLOAD: 'CONFLUENCE_UPLOAD',
  CREATE_APP: 'CREATE_APP',
  PREVIEW_FILE: 'PREVIEW_FILE',
  SELECT_TENANT: 'SELECT_TENANT',
  EDIT_USER_DETAILS: "EDIT_USER_DETAILS",
  UPDATE_PRODUCTS: "UPDATE_PRODUCTS",
  CREATE_ROLES: "CREATE_ROLES",
  UPDATE_ROLES: "UPDATE_ROLES",
  CREATE_PACKAGES: "CREATE_PACKAGES",
  UPDATE_PACKAGES: "UPDATE_PACKAGES",
  CREATE_INTEGRATION: "CREATE_INTEGRATION",
  EDIT_INTEGRATION: "EDIT_INTEGRATION",
  CREATE_GROUP: 'CREATE_GROUP',
  EDIT_GROUP: 'EDIT_GROUP',
  CREATE_UPDATE_PASTTICKKETS: 'CREATE_UPDATE_PASTTICKKETS',
  CREATE_TICKET_TYPE: 'CREATE_TICKET_TYPE',
  CREATE_PERSONA: 'CREATE_PERSONA',
  EDIT_TICKET_TYPE: 'EDIT_TICKET_TYPE',
  UPDATE_PERSONA: 'UPDATE_PERSONA',
  CREATE_AUTO_SOLVE: 'CREATE_AUTO_SOLVE',
  CLONE_AUTO_SOLVE: 'CLONE_AUTO_SOLVE',
  CREATE_TEAMS: 'CREATE_TEAMS',
  IMPORT_PAST_TICKETS: 'IMPORT_PAST_TICKETS',
  CONTROLROOM_FILTER: 'CONTROLROOM_FILTER',
  ADD_SCHEDULE: 'ADD_SCHEDULE',
  EDIT_SCHEDULE: 'EDIT_SCHEDULE',
  CLONE_FEATURE: 'CLONE_FEATURE',
  SELECT_AGENT_TYPE: 'SELECT_AGENT_TYPE',
  ADD_SOURCE: 'ADD_SOURCE',
  SLACK_UPLOAD: 'SLACK_UPLOAD',
  Edit_Custom_Field: 'Edit_Custom_Field',
  SHAREPOINT_UPLOAD: 'SHAREPOINT_UPLOAD',
  CREATE_ALERTS: 'CREATE_ALERTS',
  CREATE_REPORTS: 'CREATE_REPORTS',
  TICKET_DETAILS: 'TICKET_DETAILS',
  CREATE_DATASET: 'CREATE_DATASET',
  IMPORT_AUTOSOLVE_PROGRESS: 'IMPORT_AUTOSOLVE_PROGRESS',
  IMPORT_WORKFLOW_PROGRESS: 'IMPORT_WORKFLOW_PROGRESS',
  IMPORT_WORKFLOW_NAME_CONFLICT: 'IMPORT_WORKFLOW_NAME_CONFLICT',
  EXPORT_WORKFLOW_WARNING: 'EXPORT_WORKFLOW_WARNING',
  IMPORT_WORKFLOW_WARNING: 'IMPORT_WORKFLOW_WARNING',
  CREATE_LLM_DB_AI: 'CREATE_LLM_DB_AI',
  CREATE_LLM_DB_DB: 'CREATE_LLM_DB_DB',
  INSIGHTS_CUSTOM_API: 'INSIGHTS_CUSTOM_API',
}

const MODAL_COMPONENTS: any = {
  [MODAL_TYPES.CREATE_UPDATE_FOLDER]: {
    title: 'New Folder',
    Component: CreateUpdateFolderForm,
  },
  [MODAL_TYPES.UPDATE_FILE]: {
    title: 'Update Folder',
    Component: CreateUpdateFolderForm,
  },
  [MODAL_TYPES.DELETE_FILE]: {
    title: 'Delete',
    Component: DeleteFileForm,
  },
  [MODAL_TYPES.MULTI_FILE_UPLOAD]: {
    title: 'Upload Files',
    Component: MultiUploadList,
  },
  [MODAL_TYPES.DELETE_FOLDER]: {
    title: 'Delete',
    Component: DeleteFolderForm,
  },
  [MODAL_TYPES.ADD_TAGS]: {
    title: 'Add Tags',
    Component: AddTagsForm,
  },
  [MODAL_TYPES.ADD_EXAMPLES]: {
    title: 'Add Examples',
    Component: AddExamplesForm,
  },
  [MODAL_TYPES.ADD_COMMENTS]: {
    title: 'Add Comments',
    Component: AddCommentsForm,
  },
  [MODAL_TYPES.ADD_PARAMETER]: {
    title: 'Add Parameter',
    Component: AddParameterForm,
  },
  [MODAL_TYPES.EDIT_PARAMETER]: {
    title: 'Edit Parameter',
    Component: AddParameterForm,
  },
  [MODAL_TYPES.LOGOUT]: {
    title: 'Logout',
    Component: LogoutConfirm,
  },
  [MODAL_TYPES.CONFIRMATION]: {
    title: 'Confirmation',
    Component: ConfirmationForm,
  },
  [MODAL_TYPES.UPLOAD_URL]: {
    title: 'Upload URL',
    Component: UploadUrlForm,
  },
  [MODAL_TYPES.CONFLUENCE_UPLOAD]: {
    title: 'Upload From Confluence',
    Component: UploadConfluenceForm,
  },
  [MODAL_TYPES.SLACK_UPLOAD]: {
    title: 'Upload From Slack',
    Component: UploadSlackForm,
  },
  [MODAL_TYPES.CREATE_APP]: {
    title: 'Create New App',
    Component: CreateAppForm,
  },
  [MODAL_TYPES.PREVIEW_FILE]: {
    title: 'File Preview',
    Component: FilePreviewer,
    customProps: {
      height: '100vh',
    },
  },
  [MODAL_TYPES.SELECT_TENANT]: {
    title: 'Select Tenant',
    Component: selectTenant,
  },
  [MODAL_TYPES.EDIT_USER_DETAILS]: {
    title: 'Edit User Details',
    Component: EditUserDetails,
  },
  [MODAL_TYPES.UPDATE_PRODUCTS]: {
    title: 'Products',
    Component: ProductUpdate,
  },
  [MODAL_TYPES.CREATE_ROLES]: {
    title: "Create Roles",
    Component: AddRoles
  },
  [MODAL_TYPES.UPDATE_ROLES]: {
    title: "Update Role",
    Component: AddRoles
  },
  [MODAL_TYPES.CREATE_PACKAGES]: {
    title: "Create Packages",
    Component: AddPackages
  },
  [MODAL_TYPES.UPDATE_PACKAGES]: {
    title: "Update Packages",
    Component: AddPackages
  },
  [MODAL_TYPES.CREATE_INTEGRATION]: {
    title: "Create New Integration",
    Component: AddIntegrations
  },
  [MODAL_TYPES.EDIT_INTEGRATION]: {
    title: "Edit Integrations",
    Component: AddIntegrations
  },
  [MODAL_TYPES.CREATE_GROUP]: {
    title: " Create Group",
    Component: CreateGroup
  },
  [MODAL_TYPES.EDIT_GROUP]: {
    title: " Edit Group",
    Component: CreateGroup
  },
  [MODAL_TYPES.CREATE_TICKET_TYPE]: {
    title: "Create ",
    Component: TicketSettings
  },
  [MODAL_TYPES.EDIT_TICKET_TYPE]: {
    title: "Edit ",
    Component: TicketSettings
  },
  [MODAL_TYPES.CREATE_PERSONA]: {
    title: 'Create Persona',
    Component: Persona
  },
  [MODAL_TYPES.UPDATE_PERSONA]: {
    title: 'Update Persona',
    Component: Persona
  },
  [MODAL_TYPES.CREATE_UPDATE_PASTTICKKETS]: {
    title: 'Add Group',
    Component: CreateUpdatePastTicketsForm,
  },
  [MODAL_TYPES.CREATE_AUTO_SOLVE]: {
    title: 'Add New AI Agent',
    Component: AddName,
  },
  [MODAL_TYPES.CLONE_AUTO_SOLVE]: {
    title: 'Clone AI Agent',
    Component: AddName,
  },
  [MODAL_TYPES.CLONE_FEATURE]: {
    title: 'Clone Feature',
    Component: AddName,
  },
  [MODAL_TYPES.CREATE_TEAMS]: {
    title: 'Create Teams',
    Component: CreateTeam,
  },
  [MODAL_TYPES.IMPORT_PAST_TICKETS]: {
    title: 'Import',
    Component: ImportPastTickets,
    customProps: {
      width: 560,
      centered: true,
    },
  },
  [MODAL_TYPES.CONTROLROOM_FILTER]: {
    title: '',
    Component: ControlroomFilter,
  },
  [MODAL_TYPES.ADD_SCHEDULE]: {
    title: 'Add Schedule',
    Component: AddSchedule,
  },
  [MODAL_TYPES.EDIT_SCHEDULE]: {
    title: 'Edit Schedule',
    Component: AddSchedule,
  },

  [MODAL_TYPES.SELECT_AGENT_TYPE]: {
    title: <WizrText type='body2' textColor='black'>Set Up</WizrText>,
    Component: AgentTypeSelection
  },
  [MODAL_TYPES.ADD_SOURCE]: {
    title: 'Add Sources',
    Component: AddSourceModal,

  },
  [MODAL_TYPES.Edit_Custom_Field]: {
    title: 'Edit Custom Field',
    Component: EditCustomField,
  },
  [MODAL_TYPES.SHAREPOINT_UPLOAD]: {
    title: 'Upload From SharePoint',
    Component: UploadSharePointForm,
  },
  [MODAL_TYPES.CREATE_ALERTS]: {
    title: 'New Alert',
    Component: NewAlertForm,
  },
  [MODAL_TYPES.CREATE_REPORTS]: {
    title: 'New Report',
    Component: NewReportForm,
  },
  [MODAL_TYPES.TICKET_DETAILS]: {
    title: '',
    Component: TicketDetailsModal,
    customProps: {
      width: 600,
    },
  },
  [MODAL_TYPES.CREATE_DATASET]: {
    title: 'Create New Dataset',
    Component: CreateDataset,
  },
  [MODAL_TYPES.IMPORT_AUTOSOLVE_PROGRESS]: {
    title: '',
    Component: ImportAutosolveProgress,
    customProps: {
      width: 735,
      maskClosable: false,
    },
  },
  [MODAL_TYPES.IMPORT_WORKFLOW_PROGRESS]: {
    title: '',
    Component: ImportWorkflowProgress,
    customProps: {
      width: 735,
      maskClosable: false,
    },
  },
  [MODAL_TYPES.IMPORT_WORKFLOW_NAME_CONFLICT]: {
    title: '',
    Component: ImportWorkflowNameConflict,
    customProps: {
      width: 520,
      height: 200,
      maskClosable: false,
    },
  },
  [MODAL_TYPES.EXPORT_WORKFLOW_WARNING]: {
    title: '',
    Component: ExportWorkflowWarning,
    customProps: {
      width: 350,
      maskClosable: true,
    },
  },
  [MODAL_TYPES.IMPORT_WORKFLOW_WARNING]: {
    title: '',
    Component: ImportWorkflowWarning,
    customProps: {
      width: 350,
      maskClosable: true,
    },
  },
  [MODAL_TYPES.CREATE_LLM_DB_AI]: {
    title: 'Create new AI',
    Component: CreateLlmDbForm,
    customProps: {
      width: 920,
    },
  },
  [MODAL_TYPES.CREATE_LLM_DB_DB]: {
    title: 'Create new DB',
    Component: CreateLlmDbForm,
    customProps: {
      width: 920,
    },
  },
  [MODAL_TYPES.INSIGHTS_CUSTOM_API]: {
    title: 'Custom API',
    Component: InsightsCustomApiModal,
    customProps: {
      width: 600,
    },
  },
}


type GlobalModalContext = {
  showModal: (modalType: string, modalProps?: any) => void
  hideModal: () => void
  store: any
}

const initalState: GlobalModalContext = {
  showModal: () => { console.log('show acion') },
  hideModal: () => { console.log('hide acion') },
  store: {},
}

const WizrModalContext = createContext(initalState)
const useWizrModalContext = () => useContext(WizrModalContext)

const WizrModalProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  const location = useLocation()
  const navigationType = useNavigationType()
  const [store, setStore] = useState<any>()
  const { modalType, modalProps } = store || {}

  const showModal = (modalType: string, modalProps: any = {}) => {
    setStore((prev: any) => ({
      ...prev,
      modalType,
      modalProps,
      openedAtLocationKey: location.key,
    }))
  }

  const hideModal = () => {
    setStore((prev: any) => ({
      ...prev,
      modalType: null,
      modalProps: {},
      openedAtLocationKey: null,
    }))
  }

  // On browser back/forward, close only modals that were opened on a different route entry.
  useEffect(() => {
    if (navigationType !== 'POP') return
    setStore((prev: any) => {
      if (!prev?.modalType) return prev
      if (prev.openedAtLocationKey === location.key) return prev
      return {
        ...prev,
        modalType: null,
        modalProps: {},
        openedAtLocationKey: null,
      }
    })
  }, [location.key, navigationType])

  const renderComponent = (): JSX.Element => {
    const ModalComponent = MODAL_COMPONENTS[modalType]?.Component
    const modalTitle = MODAL_COMPONENTS[modalType]?.title
    const customProps = MODAL_COMPONENTS[modalType]?.customProps
    const resolvedTitle = modalProps?.modalTitle ?? modalTitle

    if (!modalType || !ModalComponent) {
      return <></>
    }

    const maskClosable = customProps?.maskClosable !== false
    const showCloseButton = maskClosable || customProps?.closeButtonOnly === true
    return (
      <Modal
        title={resolvedTitle && resolvedTitle !== '' ? <WizrText type='sub1'>{resolvedTitle}</WizrText> : null}
        open={true}
        footer={null}
        onCancel={showCloseButton ? hideModal : undefined}
        forceRender={false}
        maskClosable={maskClosable}
        closeIcon={showCloseButton ? undefined : <></>}
        destroyOnClose={true}
        width={customProps?.width}
        centered={customProps?.centered ?? false}
        style={{
          ...(customProps?.centered ? {} : { top: '10%' }),
          maxHeight: '80vh',
          ...(customProps?.style || {})
        }}
        bodyStyle={{
          maxHeight: 'calc(90vh - 120px)', // Subtract header height
          overflow: 'auto',
          padding: 0
        }}
      >
        <StyledLayout alignItems='flex-start' background='#FFF' style={{ height: '100%', overflow: 'auto' }}>
          <ModalComponent id='global-modal' {...modalProps} />
        </StyledLayout>
      </Modal>
    )
  }

  return (
    <WizrModalContext.Provider value={{ store, showModal, hideModal }}>
      {renderComponent()}
      {children}
    </WizrModalContext.Provider>
  )
}

export { MODAL_TYPES, useWizrModalContext, WizrModalProvider }
